import React from "react";
import Footer from "../components/layout/Footer";
import Navbar from "../components/layout/Navbar";
import man from "../assets/img/f088c8365a.jpeg";
import PlanButtons from "../components/PlanButtons";
import Possibilities from "../components/Possibilities";

function ForHomes() {
  return (
    <div class="main-container">
      <Navbar />
      {/* <div className="" id="google_translate_element"></div> */}
      <div class="first-banner col-12 col-lg-11 ml-lg-5 d-flex">
        <div class="col-md-6 mr-auto d-none d-md-block">
          <p class="unlimited mb-0">
            Obtenez <br />
            Internet résidentiel illimité <br />
            pour <span>FCFA 17,500</span> <br />
            mensuel.
          </p>
          <div class="create mt-3">
            <button type="submit" class="btn signup-btn p-2 w-25">
              <a href="/civwifi/#/sign-up">S'inscrire</a>
            </button>
          </div>
        </div>

        <div class="col-md-6 mr-auto d-sm-block d-md-none">
          <p class="unlimited mb-0">
            Obtenez Internet résidentiel illimité pour <span>FCFA 17,500</span>{" "}
            mensuel.
          </p>
          <div class="create mt-3">
            <button type="submit" class="btn signup-btn p-2 w-25">
              <a href="/civwifi/#/sign-up">S'inscrire</a>
            </button>
          </div>
        </div>

        <div class="col-md-6 family p-0 d-none d-md-block">
          <img
            src={man}
            class="img-fluid mt-5"
          />
        </div>
      </div>

      <div class="carrier1 carrier col-12 col-lg-11 ml-lg-5" id="whyGhana">
        <h5 class="ml-3">How it works</h5>
        <div class="col-12 p-0 d-flex flex-wrap">
          <div class="col-12 col-md-4">
            <div class="d-flex shadow bg-white p-3 mb-4">
              <div class="mr-3 mt-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273634/note_zyzvuz.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5 class="text-center w-25">1</h5>
                <h5>S'inscrire</h5>
                <p>
                  Remplissez un court formulaire d'inscription avec vos
                  informations pertinentes.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4">
            <div class="d-flex shadow bg-white p-3 mb-4">
              <div class="mr-3 mt-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273632/Frame_quzjgm.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5 class="text-center w-25">2</h5>
                <h5>Effectuer le paiement</h5>
                <p>
                  Effectuez un paiement à partir de l'une de nos plateformes de
                  paiement
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 pr-0 d-none d-md-block">
            <div class="d-flex shadow bg-white p-3 mb-4">
              <div class="mr-3 mt-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273632/calendar_sgxljs.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5 class="text-center w-25">3</h5>
                <h5>Obtenir un horaire</h5>
                <p>
                  Obtenez un horaire adapté parmi nos horaires disponibles pour
                  votre installation.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-4 d-md-none d-sm-block">
            <div class="d-flex shadow bg-white p-3 mb-4">
              <div class="mr-3 mt-3">
                <img
                  src="https://res.cloudinary.com/ghanawifi/image/upload/v1560273632/calendar_sgxljs.png"
                  class="mt-4"
                />
              </div>
              <div>
                <h5 class="text-center w-25">3</h5>
                <h5>Obtenir un horaire</h5>
                <p>
                  Nous apprécions votre temps et nous veillons à résoudre tous
                  les problèmes que vous pourriez avoir dans les plus brefs
                  délais.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Possibilities />
      <PlanButtons />
      <Footer />
    </div>
  );
}

export default ForHomes;
